<template>
  <div class="animated fadeIn pt2 pb4">
    <div class="clearfix gibson px2 py3 mb2">
      <div class="col-12 px2">
        <div class="clearfix border muted-border p2 py3 shadow" v-if="showMobile">
          <div class="col-12 px2 gibson">
            <p class="h4 semi-bold line-height-2 my2 darkblue">Notifikationer</p>
            <p class="h5 regular darkblue line-height-golden mb3">
              Se status på dine notifikationer og slå dem til eller fra.
            </p>
          </div>
          <form class="col-12 px0" v-if="imentor">
            <!-- general -->
            <div class="clearfix py1 mb2">
              <div class="xs-col-12 sm-col-12 md-col-9 lg-col-9 px2 flex justify-between items-center">
                <button v-b-toggle.details1 class="col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson">
                  <p class="h5 semi-bold line-height-1 mb0">
                    Generelle notifikationer
                  </p>
                  <!-- opened/closed toggle -->
                  <span class="flex-none when-closed">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                  </span>
                  <span class="flex-none when-opened">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                    </span>
                  </span>
                </button>
              </div>
              <b-collapse id="details1" class="p2">
                <p class="h5 gibson regular darkblue line-height-golden">
                  Når du har aktiveret servicepåmindelser pr. SMS modtager du dagen efter en booking en SMS-besked med kundens navn og telefonnummer samt mødedatoen.
                  <br><br>Du kan slå notifikationer til og fra her.
                </p>
                <div class="flex justify-start items-center">
                  <div class="my2">
                    <label class="switch switch-icon switch-success switch-pill switch-md">
                      <input type="checkbox" class="switch-input" value="1" v-model="service_reminder" true-value=1  false-value=0>
                      <span data-on="" data-off="" class="switch-label"></span>
                      <span class="switch-handle"></span>
                    </label>
                  </div>
                </div>
                <div class="py-2"></div>
                <button type="button" class="xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold" @click="service_reminder_action()">
                  <span>Gem</span>
                  <span class="mx2"><i class="el-icon-right"></i></span>
                </button>
              </b-collapse>
            </div>
            <!-- sms -->
            <div class="clearfix py1 mb2">
              <div class="xs-col-12 sm-col-12 md-col-9 lg-col-9 px2 flex justify-between items-center">
                <button v-b-toggle.details3 class="col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson">
                  <p class="h5 semi-bold line-height-1 mb0">
                    Deaktiver SMS-tilbud
                  </p>
                  <!-- opened/closed toggle -->
                  <span class="flex-none when-closed">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                  </span>
                  <span class="flex-none when-opened">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                    </span>
                  </span>
                </button>
              </div>
              <b-collapse id="details3" class="p2">
                <p class="h5 gibson regular darkblue line-height-golden">
                  Har du i perioder ikke brug for at modtage SMS'er om nye potentielle kunder, så kan du slå SMS-notifikationerne til og fra her.
                  <br><br>
                  Der vil gå ca. 24 timer, før vores system kan registrere deaktivering, og i denne periode kan du stadig opleve at modtage SMS'er.
                </p>
                <div class="flex justify-start items-center">
                  <div class="my2">
                    <label class="switch switch-icon switch-success switch-pill switch-md">
                      <input type="checkbox" class="switch-input" value="1" v-model="inactivesms" true-value=1  false-value=0>
                      <span data-on="" data-off="" class="switch-label"></span>
                      <span class="switch-handle"></span>
                    </label>
                  </div>
                </div>
                <div class="py-2"></div>
                <button type="button" class="xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold" @click="inactivesms_action()">
                  <span>Gem</span>
                  <span class="mx2"><i class="el-icon-right"></i></span>
                </button>
              </b-collapse>
            </div>
            <!-- daily sms -->
            <div class="clearfix py1 mb2">
              <div class="xs-col-12 sm-col-12 md-col-9 lg-col-9 px2 flex justify-between items-center">
                <button v-b-toggle.details4 class="col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson">
                  <p class="h5 semi-bold line-height-1 mb0">
                    Daglige SMS-tilbud
                  </p>
                  <!-- opened/closed toggle -->
                  <span class="flex-none when-closed">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                  </span>
                  <span class="flex-none when-opened">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                    </span>
                  </span>
                </button>
              </div>
              <b-collapse id="details4" class="p2">
                <p class="h5 gibson regular darkblue line-height-golden">
                  Her kan du ændre indstillingerne for info-SMS'er om ledige kundemøder, som du kan købe.
                </p>
                <div class="flex flex-column">
                  <select class="muted-background darkblue h5 gibson p2 border-none not-rounded" v-model="sms_size" id="sms_size" required style="font-size:1.25rem;">
                    <option v-for="n in 10" :key="n" :value="n">{{ n }}</option>
                  </select>
                  <p class="h5 regular gibson darkblue line-height-3 mt3 mb1">Radius for opgavens placering (fra din firmaadresse)</p>
                  <b-form-select v-model="sms_distance" id="sms_distance" required :options="optionsDistance" class="muted-background darkblue gibson px2 py1 border-none not-rounded" style="font-size:1.25rem;">
                  </b-form-select>
                </div>
                <div class="py2"></div>
                <button type="button" class="xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold" @click="inactivesms_action()">
                  <span>Gem</span>
                  <span class="mx2"><i class="el-icon-right"></i></span>
                </button>
              </b-collapse>
            </div>
            <!-- servicepåmindelse - 1 day before - two hours before -->
            <div class="clearfix py1 mb2">
              <div class="xs-col-12 sm-col-12 md-col-9 lg-col-9 px2 flex justify-between items-center">
                <button v-b-toggle.details5 class="col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson">
                  <p class="h5 semi-bold line-height-1 mb0">
                    Servicepåmindelse
                  </p>
                  <!-- opened/closed toggle -->
                  <span class="flex-none when-closed">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                  </span>
                  <span class="flex-none when-opened">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                    </span>
                  </span>
                </button>
              </div>
              <b-collapse id="details5" class="p2">
                <div class="white-background">
                  <p class="h5 gibson regular darkblue line-height-golden">
                    <span class="block semi-bold mb1">1 dag før mødet</span>
                    Når du slår denne påmindelse til, får du en mail/SMS dagen før hvert møde.
                  </p>
                  <div class="flex flex-column">
                    <div class="my2">
                      <label class="switch switch-icon switch-success switch-pill switch-md">
                        <input type="checkbox" class="switch-input" value="0" v-model="onebeforemeeting" true-value=0  false-value=1>
                        <span data-on="" data-off="" class="switch-label"></span>
                        <span class="switch-handle"></span>
                      </label>
                    </div>
                    <p class="h6 gibson regular darkblue line-height-golden">Vælg metode</p>
                    <b-form-select v-model="onebefore_sms_email" id="onebefore_sms_email" required class="muted-background h6 gibson regular border-none not-rounded" style="font-size:11.5px;">
                      <option value="0">Både SMS og e-mail</option>
                      <option value="1">Kun e-mail</option>
                      <option value="2">Kun SMS</option>
                    </b-form-select>
                    <div class="py2"></div>
                    <p class="h5 gibson regular darkblue line-height-golden">
                      <span class="block semi-bold mb1">2 timer før mødet</span>
                      Når du slår denne påmindelse til, får du en SMS 2 timer før hvert møde.
                    </p>
                    <div class="my2">
                      <label class="switch switch-icon switch-success switch-pill switch-md">
                        <input type="checkbox" class="switch-input" value="0" v-model="twohourbeforemeeting" true-value=0  false-value=1>
                        <span data-on="" data-off="" class="switch-label"></span>
                        <span class="switch-handle"></span>
                      </label>
                    </div>
                  </div>
                  <button type="button" class="xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold" @click="service_other_reminder_action()">
                    <span>Gem</span>
                    <span class="mx2"><i class="el-icon-right"></i></span>
                  </button>
                </div>      
              </b-collapse>
            </div>
            <!-- bedømmelse sms -->
            <div class="clearfix py1 mb2">
              <div class="xs-col-12 sm-col-12 md-col-9 lg-col-9 px2 flex justify-between items-center">
                <button v-b-toggle.details6 class="col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson">
                  <p class="h5 semi-bold line-height-1 mb0">
                    Bedømmelses-SMS
                  </p>
                  <!-- opened/closed toggle -->
                  <span class="flex-none when-closed">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                  </span>
                  <span class="flex-none when-opened">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                    </span>
                  </span>
                </button>
              </div>
              <b-collapse id="details6" class="p2">
                <p class="h5 gibson regular darkblue line-height-golden">
                  <span class="block semi-bold mb1">Aktiver bedømmelses-SMS (2 timer efter møde)</span>
                  Her får du en SMS, hvor du kan svare med en bedømmelse af kundemødet, du lige har afholdt. Bedømmelsen bruger vi til at optimere vores service til dig.
                </p>
                <div class="flex justify-start items-center">
                  <div class="my2">
                    <label class="switch switch-icon switch-success switch-pill switch-md">
                      <input type="checkbox" class="switch-input" value="0" v-model="twohouraftermeeting" true-value=0  false-value=1>
                      <span data-on="" data-off="" class="switch-label"></span>
                      <span class="switch-handle"></span>
                    </label>
                  </div>
                </div>
                <div class="py-2"></div>
                <button type="button" class="xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold" @click="service_other_reminder_action()">
                  <span>Gem</span>
                  <span class="mx2"><i class="el-icon-right"></i></span>
                </button>
              </b-collapse>
            </div>
          </form>
          <div class="xs-col-12 sm-col-12 md-col-9 lg-col-9 px0">
            <div class="clearfix mb2">
              <div class="clearfix mb2" v-for="item in items" :key="item.workflow_id">
                <div class="col-12 px2">
                  <button v-b-toggle="'details_'+ item.workflow_id" class="col-12 px0 simple-button border-none py2 flex justify-between items-center gibson">
                    <p class="h6 semi-bold line-height-1 mb0 left-align">
                      {{ item.title }}
                    </p>
                    <!-- opened/closed toggle -->
                    <span class="flex-none when-closed">
                      <span class="relative" style="top:3px;">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </span>
                    <span class="flex-none when-opened">
                      <span class="relative" style="top:3px;">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                      </span>
                    </span>
                  </button>
                </div>
                <b-collapse :id="'details_'+ item.workflow_id" class="gibson px2">
                  <p class="h5 gibson regular darkblue line-height-golden mb0">
                    {{ item.note }}
                  </p>
                  <div class="flex justify-start items-center">
                    <div class="my2">
                      <label class="switch switch-icon switch-success switch-pill switch-md">
                        <input type="checkbox" class="switch-input" :value="item.select" :id="'option_' + item.workflow_id"  v-model="item.select"  true-value=1  false-value=0>
                        <span data-on="" data-off="" class="switch-label"></span>
                        <span class="switch-handle"></span>
                      </label>
                    </div>
                  </div>
                  <div class="py-2"></div>
                  <button type="button" class="xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold" @click="workflow_action(item.workflow_id)">
                    <span>Gem</span>
                    <span class="mx2"><i class="el-icon-right"></i></span>
                  </button>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix ml4" v-if="!showMobile">
          <div class="col-12 px2 gibson">
            <p class="h4 semi-bold line-height-2 my2 darkblue">Notifikationer</p>
            <p class="h5 regular darkblue line-height-golden mb3">
              Se status på dine notifikationer og slå dem til eller fra.
            </p>
          </div>
          <form class="flex flex-wrap px0" v-if="imentor">
            <!-- general -->
            <div class="col-4 mb2">
              <div class="flex justify-between items-center">
                <button v-b-toggle.details1 class="col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson">
                  <p class="h5 semi-bold line-height-1 mb0">
                    Generelle notifikationer
                  </p>
                  <!-- opened/closed toggle -->
                  <span class="flex-none when-closed">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                  </span>
                  <span class="flex-none when-opened">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                    </span>
                  </span>
                </button>
              </div>
              <b-collapse id="details1" class="p2">
                <p class="h5 gibson regular darkblue line-height-golden">
                  Når du har aktiveret servicepåmindelser pr. SMS modtager du dagen efter en booking en SMS-besked med kundens navn og telefonnummer samt mødedatoen.
                  <br><br>Du kan slå notifikationer til og fra her.
                </p>
                <div class="flex justify-start items-center">
                  <div class="my2">
                    <label class="switch switch-icon switch-success switch-pill switch-md">
                      <input type="checkbox" class="switch-input" value="1" v-model="service_reminder" true-value=1  false-value=0>
                      <span data-on="" data-off="" class="switch-label"></span>
                      <span class="switch-handle"></span>
                    </label>
                  </div>
                </div>
                <div class="py-2"></div>
                <button type="button" class="xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold" @click="service_reminder_action()">
                  <span>Gem</span>
                  <span class="mx2"><i class="el-icon-right"></i></span>
                </button>
              </b-collapse>
            </div>
            <!-- sms -->
            <div class="col-4 mb2">
              <div class="flex justify-between items-center">
                <button v-b-toggle.details3 class="col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson">
                  <p class="h5 semi-bold line-height-1 mb0">
                    Deaktiver SMS-tilbud
                  </p>
                  <!-- opened/closed toggle -->
                  <span class="flex-none when-closed">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                  </span>
                  <span class="flex-none when-opened">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                    </span>
                  </span>
                </button>
              </div>
              <b-collapse id="details3" class="p2">
                <p class="h5 gibson regular darkblue line-height-golden">
                  Har du i perioder ikke brug for at modtage SMS'er om nye potentielle kunder, så kan du slå SMS-notifikationerne til og fra her.
                  <br><br>
                  Der vil gå ca. 24 timer, før vores system kan registrere deaktivering, og i denne periode kan du stadig opleve at modtage SMS'er.
                </p>
                <div class="flex justify-start items-center">
                  <div class="my2">
                    <label class="switch switch-icon switch-success switch-pill switch-md">
                      <input type="checkbox" class="switch-input" value="1" v-model="inactivesms" true-value=1  false-value=0>
                      <span data-on="" data-off="" class="switch-label"></span>
                      <span class="switch-handle"></span>
                    </label>
                  </div>
                </div>
                <div class="py-2"></div>
                <button type="button" class="xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold" @click="inactivesms_action()">
                  <span>Gem</span>
                  <span class="mx2"><i class="el-icon-right"></i></span>
                </button>
              </b-collapse>
            </div>
            <!-- daily sms -->
            <div class="col-4 mb2">
              <div class="flex justify-between items-center">
                <button v-b-toggle.details4 class="col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson">
                  <p class="h5 semi-bold line-height-1 mb0">
                    Daglige SMS-tilbud
                  </p>
                  <!-- opened/closed toggle -->
                  <span class="flex-none when-closed">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                  </span>
                  <span class="flex-none when-opened">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                    </span>
                  </span>
                </button>
              </div>
              <b-collapse id="details4" class="p2">
                <p class="h5 gibson regular darkblue line-height-golden">
                  Her kan du ændre indstillingerne for info-SMS'er om ledige kundemøder, som du kan købe.
                </p>
                <div class="flex flex-column">
                  <select class="muted-background darkblue h5 gibson p2 border-none not-rounded" v-model="sms_size" id="sms_size" required style="font-size:1.25rem;">
                    <option v-for="n in 10" :key="n" :value="n">{{ n }}</option>
                  </select>
                  <p class="h5 regular gibson darkblue line-height-3 mt3 mb1">Radius for opgavens placering (fra din firmaadresse)</p>
                  <b-form-select v-model="sms_distance" id="sms_distance" required :options="optionsDistance" class="muted-background darkblue gibson px2 py1 border-none not-rounded" style="font-size:1.25rem;">
                  </b-form-select>
                </div>
                <div class="py2"></div>
                <button type="button" class="xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold" @click="inactivesms_action()">
                  <span>Gem</span>
                  <span class="mx2"><i class="el-icon-right"></i></span>
                </button>
              </b-collapse>
            </div>
            <!-- servicepåmindelse - 1 day before - two hours before -->
            <div class="col-4 mb2">
              <div class="flex justify-between items-center">
                <button v-b-toggle.details5 class="col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson">
                  <p class="h5 semi-bold line-height-1 mb0">
                    Servicepåmindelse
                  </p>
                  <!-- opened/closed toggle -->
                  <span class="flex-none when-closed">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                  </span>
                  <span class="flex-none when-opened">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                    </span>
                  </span>
                </button>
              </div>
              <b-collapse id="details5" class="p2">
                <div class="white-background">
                  <p class="h5 gibson regular darkblue line-height-golden">
                    <span class="block semi-bold mb1">1 dag før mødet</span>
                    Når du slår denne påmindelse til, får du en mail/SMS dagen før hvert møde.
                  </p>
                  <div class="flex flex-column">
                    <div class="my2">
                      <label class="switch switch-icon switch-success switch-pill switch-md">
                        <input type="checkbox" class="switch-input" value="0" v-model="onebeforemeeting" true-value=0  false-value=1>
                        <span data-on="" data-off="" class="switch-label"></span>
                        <span class="switch-handle"></span>
                      </label>
                    </div>
                    <p class="h6 gibson regular darkblue line-height-golden">Vælg metode</p>
                    <b-form-select v-model="onebefore_sms_email" id="onebefore_sms_email" required class="muted-background h6 gibson regular border-none not-rounded" style="font-size:11.5px;">
                      <option value="0">Både SMS og e-mail</option>
                      <option value="1">Kun e-mail</option>
                      <option value="2">Kun SMS</option>
                    </b-form-select>
                    <div class="py2"></div>
                    <p class="h5 gibson regular darkblue line-height-golden">
                      <span class="block semi-bold mb1">2 timer før mødet</span>
                      Når du slår denne påmindelse til, får du en SMS 2 timer før hvert møde.
                    </p>
                    <div class="my2">
                      <label class="switch switch-icon switch-success switch-pill switch-md">
                        <input type="checkbox" class="switch-input" value="0" v-model="twohourbeforemeeting" true-value=0  false-value=1>
                        <span data-on="" data-off="" class="switch-label"></span>
                        <span class="switch-handle"></span>
                      </label>
                    </div>
                  </div>
                  <button type="button" class="xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold" @click="service_other_reminder_action()">
                    <span>Gem</span>
                    <span class="mx2"><i class="el-icon-right"></i></span>
                  </button>
                </div>      
              </b-collapse>
            </div>
            <!-- bedømmelse sms -->
            <div class="col-4 mb2">
              <div class="flex justify-between items-center">
                <button v-b-toggle.details6 class="col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson">
                  <p class="h5 semi-bold line-height-1 mb0">
                    Bedømmelses-SMS
                  </p>
                  <!-- opened/closed toggle -->
                  <span class="flex-none when-closed">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                  </span>
                  <span class="flex-none when-opened">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                    </span>
                  </span>
                </button>
              </div>
              <b-collapse id="details6" class="p2">
                <p class="h5 gibson regular darkblue line-height-golden">
                  <span class="block semi-bold mb1">Aktiver bedømmelses-SMS (2 timer efter møde)</span>
                  Her får du en SMS, hvor du kan svare med en bedømmelse af kundemødet, du lige har afholdt. Bedømmelsen bruger vi til at optimere vores service til dig.
                </p>
                <div class="flex justify-start items-center">
                  <div class="my2">
                    <label class="switch switch-icon switch-success switch-pill switch-md">
                      <input type="checkbox" class="switch-input" value="0" v-model="twohouraftermeeting" true-value=0  false-value=1>
                      <span data-on="" data-off="" class="switch-label"></span>
                      <span class="switch-handle"></span>
                    </label>
                  </div>
                </div>
                <div class="py-2"></div>
                <button type="button" class="xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold" @click="service_other_reminder_action()">
                  <span>Gem</span>
                  <span class="mx2"><i class="el-icon-right"></i></span>
                </button>
              </b-collapse>
            </div>
          </form>
          <div class="flex flex-wrap">
            <div class="col-4 mb2" v-for="item in items" :key="item.workflow_id">
              <div>
                <button v-b-toggle="'details_'+ item.workflow_id" class="col-12 px0 simple-button border-none py2 flex justify-between items-center gibson">
                  <p class="h6 semi-bold line-height-1 mb0 left-align">
                    {{ item.title }}
                  </p>
                  <!-- opened/closed toggle -->
                  <span class="flex-none when-closed">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                  </span>
                  <span class="flex-none when-opened">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                    </span>
                  </span>
                </button>
              </div>
              <b-collapse :id="'details_'+ item.workflow_id" class="gibson px2">
                <p class="h5 gibson regular darkblue line-height-golden mb0">
                  {{ item.note }}
                </p>
                <div class="flex justify-start items-center">
                  <div class="my2">
                    <label class="switch switch-icon switch-success switch-pill switch-md">
                      <input type="checkbox" class="switch-input" :value="item.select" :id="'option_' + item.workflow_id"  v-model="item.select"  true-value=1  false-value=0>
                      <span data-on="" data-off="" class="switch-label"></span>
                      <span class="switch-handle"></span>
                    </label>
                  </div>
                </div>
                <div class="py-2"></div>
                <button type="button" class="xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold" @click="workflow_action(item.workflow_id)">
                  <span>Gem</span>
                  <span class="mx2"><i class="el-icon-right"></i></span>
                </button>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py2"></div>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import hotlinemodal from './modals/HotlineModal'
import archivemodal from './modals/ArchiveModal'
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import Imentor from './imentor'
export default {
  name: 'profilesettings',
  data () {
    return {
      service_reminder: '',
      items: [],
      optionsDistance: [],
      autobooking: '',
      partnertype: 'SMS-partner',
      show: false,
      imentor: true,
      label: 'Loading...',
      overlay: 1,
      inactivesms: '',
      sms_size: '',
      sms_distance: '',
      onebeforemeeting: '',
      onebefore_sms_email: '',
      twohourbeforemeeting: '',
      twohouraftermeeting: '',
      twodayaftermeeting: '',
      twodayafter_sms_email: '',
      twodayafter_days: '',
      tendayaftermeeting: '',
      tendayafter_sms_email: '',
      tendayafter_days: '',
      salesPerson: ''
    }
  },
  components: {
    Imentor,
    hotlinemodal,
    archivemodal,
    loading,
    Simplert
  },
  created () {
    this.Reload()
    if (localStorage.getItem('imentor') === '0') {
      this.imentor = false
    }
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  methods: {
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1'}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.service_reminder = res.service_reminder
            this.partnertype = res.partnertype
            this.autobooking = res.autobooking
            this.inactivesms = res.inactivesms
            this.sms_size = res.sms_size
            this.sms_distance = res.id_distancesms
            if (this.sms_distance === '') {
              this.sms_distance = res.partnerdistancesmsfirst
            }
            this.optionsDistance = res.smsdistanceList
            this.onebeforemeeting = res.onebeforemeeting
            this.onebefore_sms_email = res.onebefore_sms_email
            this.twohourbeforemeeting = res.twohourbeforemeeting
            this.twohouraftermeeting = res.twohouraftermeeting
            this.twodayaftermeeting = res.twodayaftermeeting
            this.twodayafter_sms_email = res.twodayafter_sms_email
            this.twodayafter_days = res.twodayafter_days
            this.tendayaftermeeting = res.tendayaftermeeting
            this.tendayafter_sms_email = res.tendayafter_sms_email
            this.tendayafter_days = res.tendayafter_days
            this.items = res.workflows
          },
          response => {
            alert('error')
          }
        )
    },
    service_reminder_action () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')

      var dataPartner = {operation: 'servicereminder', salesPerson: this.salesPerson, service_reminder: this.service_reminder}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    service_autobooking_action () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'autobooking', salesPerson: this.salesPerson, autobooking: this.autobooking}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    inactivesms_action () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'inactivesms', salesPerson: this.salesPerson, inactivesms: this.inactivesms, sms_size: this.sms_size, sms_distance: this.sms_distance}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    service_other_reminder_action () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = { operation: 'servicereotherminder', salesPerson: this.salesPerson, onebeforemeeting: this.onebeforemeeting, onebefore_sms_email: this.onebefore_sms_email, twohourbeforemeeting: this.twohourbeforemeeting, twohouraftermeeting: this.twohouraftermeeting, twodayaftermeeting: this.twodayaftermeeting, twodayafter_sms_email: this.twodayafter_sms_email, twodayafter_days: this.twodayafter_days, tendayaftermeeting: this.tendayaftermeeting, tendayafter_sms_email: this.tendayafter_sms_email, tendayafter_days: this.tendayafter_days }
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    workflow_action (workflow) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var elementCheckBox = document.getElementById('option_' + workflow)
      var dataPartner = {operation: 'workflow_action', salesPerson: this.salesPerson, workflow_id: workflow, checked: elementCheckBox.checked}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    }
  }
}
</script>
<style scoped>
.modal-header,
.modal-footer {
  border-top: 0;
  border-bottom: 0;
}
.card-footer {
  border-top: 0;
  border-bottom: 0;
  background-color: #fff;
}
.switch-success > .switch-input:not(checked) ~ .switch-label {
  background: #CF000F;
  color: #fff;
  border: 0;
}
.switch-success > .switch-input:not(checked) ~ .switch-label::before {
  color: #fff!important;
}
.fa-exclamation-triangle {
  font-size: 26px;
}
</style>


// WEBPACK FOOTER //
// ProfileSettings.vue?4fdf3295